import { Identifiable } from '@lessonup/utils';
import { School } from './SchoolSuggestion';

export interface IndexedSchoolSuggestion extends Identifiable {
  _id: string;
  name: string;
  globalSchoolId: string;
  city: string;
  address?: string;
  country: string;
  organizationId?: string;
  schoolType?: string;
  isSuper?: boolean;
}

export namespace IndexedSchoolSuggestion {
  export function from(school: School): IndexedSchoolSuggestion {
    return mapSchool(school);
  }

  function mapSchool(school: School): IndexedSchoolSuggestion {
    return {
      _id: school._id,
      name: school.name,
      globalSchoolId: school.globalSchoolId,
      city: school.city,
      address: school.address,
      country: school.country,
      organizationId: school.organizationId,
      schoolType: school.schoolType,
      isSuper: school.isSuper,
    };
  }
}
